export interface AssetImageDimensions {
    readonly width: number;
    readonly height: number;
}

const ASSET_IMAGE_DIMENSIONS: Readonly<Record<string, AssetImageDimensions>> = {
    'assets/alliance/img/alliance-logo-dark.webp': { width: 213, height: 156 },
    'assets/alliance/img/alliance-logo-light.webp': { width: 219, height: 160 },
    'assets/alliance/img/message-modal.webp': { width: 968, height: 518 },
    'assets/alliance/img/payment-confirmation.webp': { width: 186, height: 171 },
    'assets/choice/img/choice-logo-dark.webp': { width: 9293, height: 2922 },
    'assets/choice/img/choice-logo-light.webp': { width: 9293, height: 2922 },
    'assets/choice/img/payment-confirmation.webp': { width: 186, height: 171 },
    'assets/dhl-aviation/img/dhl-aviation-logo.webp': { width: 264, height: 102 },
    'assets/dhl-aviation/img/dhl-logo-dark.webp': { width: 438, height: 170 },
    'assets/dhl-aviation/img/dhl-logo-light.webp': { width: 438, height: 70 },
    'assets/dhl-aviation/img/logo.webp': { width: 2000, height: 283 },
    'assets/dhl-aviation/img/payment-confirmation.webp': { width: 240, height: 213 },
    'assets/dhl-prepay/img/payment-confirmation.webp': { width: 240, height: 213 },
    'assets/dsv-air/img/dsv-logo-dark.webp': { width: 243, height: 72 },
    'assets/dsv-air/img/dsv-logo-light.webp': { width: 243, height: 72 },
    'assets/dsv-air/img/payment-confirmation.webp': { width: 186, height: 171 },
    'assets/dsv-air-sea-inc/img/dsv-logo-dark.webp': { width: 243, height: 72 },
    'assets/dsv-air-sea-inc/img/dsv-logo-light.webp': { width: 243, height: 72 },
    'assets/dsv-air-sea-inc/img/payment-confirmation.webp': { width: 186, height: 171 },
    'assets/dsv-road/img/dsv-logo-dark.webp': { width: 243, height: 72 },
    'assets/dsv-road/img/dsv-logo-light.webp': { width: 243, height: 72 },
    'assets/dsv-road/img/payment-confirmation.webp': { width: 186, height: 171 },
    'assets/dsv-road-transport/img/dsv-logo-dark.webp': { width: 243, height: 72 },
    'assets/dsv-road-transport/img/dsv-logo-light.webp': { width: 243, height: 72 },
    'assets/dsv-road-transport/img/payment-confirmation.webp': { width: 186, height: 171 },
    'assets/dsv-solutions/img/dsv-logo-dark.webp': { width: 243, height: 72 },
    'assets/dsv-solutions/img/dsv-logo-light.webp': { width: 243, height: 72 },
    'assets/dsv-solutions/img/payment-confirmation.webp': { width: 186, height: 171 },
    'assets/img/logo-cargosprint-horizontal-color.webp': { width: 1212, height: 198 },
    'assets/img/powered-by-grey.webp': { width: 128, height: 32 },
    'assets/polar/img/payment-confirmation.webp': { width: 240, height: 213 },
    'assets/polar/img/polar-logo-dark.webp': { width: 426, height: 104 },
    'assets/polar/img/polar-logo-light.webp': { width: 800, height: 189 },
    'assets/polar/img/polar-message.webp': { width: 819, height: 258 },
    'assets/polar-prepay/img/payment-confirmation.webp': { width: 240, height: 213 },
    'assets/sprintpay/img/payment-confirmation.webp': { width: 186, height: 171 },
};

export const getAssetImageDimensions = (src: string | null | undefined): AssetImageDimensions | null => {
    if (!src) {
        return null;
    }

    return ASSET_IMAGE_DIMENSIONS[src] ?? null;
};

export const isSvgAsset = (src: string | null | undefined): boolean => {
    if (!src) {
        return false;
    }

    return src.toLowerCase().endsWith('.svg');
};
